import Checkbox from "./checkbox.component.js";

export default angular
    .module("oui.checkbox", [])
    .component("ouiCheckbox", Checkbox)
    .name;
